import { render, staticRenderFns } from "./CRS.List.vue?vue&type=template&id=84f6418a&"
import script from "./CRS.List.vue?vue&type=script&lang=js&"
export * from "./CRS.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports